import { Stack, Typography } from "@mui/material";
import type { DataCollectionRequestDetails } from "../../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory } from "../../../../../api/types/objectTypes";
import { dataCollectionRequestAuditoryCaptionsMap } from "../../../../../utilities/enumCaptions";
import DataRequestStatusTag from "../DataRequestStatusTag";
import { getDataRequestTemplateCategoryName } from "../dataRequestHelper";

interface Props {
  dataRequest: DataCollectionRequestDetails;
  categories: ObjectAccessCategory[];
}

const DataRequestPageTitle = ({ dataRequest, categories }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="h6" noWrap>
          {dataRequest.name}
        </Typography>
        <DataRequestStatusTag status={dataRequest.status} />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="caption" color="textSecondary">
          Data Request
        </Typography>
        <Typography variant="caption">&bull;</Typography>
        <Typography variant="caption">
          <Typography component="span" variant="caption" color="textSecondary">
            Recipient Type:{" "}
          </Typography>
          {dataCollectionRequestAuditoryCaptionsMap[dataRequest.auditory] ?? dataRequest.auditory}
        </Typography>
        <Typography variant="caption">&bull;</Typography>
        <Typography variant="caption">
          <Typography component="span" variant="caption" color="textSecondary">
            Category:{" "}
          </Typography>
          {getDataRequestTemplateCategoryName(dataRequest, categories)}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default DataRequestPageTitle;
